export default __webpack_public_path__ + "7fe7cfe0c2ebed09c511452925ffe4e1.svg";